module.exports = __webpack_public_path__ + "img/binti.51c29ac9.png";